import axios from "axios";

export default {
    async Create(data) {
        const response = await axios.post("/api/employeepsychotechnic/create", data);
        return response;
    },
    async Update(data) {
        const response = await axios.post("/api/employeepsychotechnic/update", data);
        return response;
    },
    async Table(data) {
        const response = await axios.post("/api/employeepsychotechnic/table", data);
        return response;
    },
    async Delete(id) {
        const response = await axios.post(`/api/employeepsychotechnic/delete/${id}`);
        return response;
    },
    async List() {
        const response = await axios.post("/api/employeepsychotechnic/list");
        return response;
    },
    async Report(data) {
        const response = await axios.post("/api/employeepsychotechnic/report", data);
        return response;
    },
    async Dashboard() {
        const response = await axios.get("/api/employeepsychotechnic/dashboard");
        return response;
    },
};
